import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import { Intersection } from '@splidejs/splide-extension-intersection';



export function carouselSlider() {
    document.addEventListener( 'DOMContentLoaded', function () {
        const blocks = document.querySelectorAll('.carouselSlider');

        blocks.forEach(block=>{
            new Splide(block, {
              autoplay    : true,
              pagination  : true,
              arrows      : false,
              type        : 'loop',
              interval    : 5000,

              intersection: {
                inView: {
                  autoplay: true,
                },
              },

     
              }).mount( { Intersection } );
        })
    })
}
